module.exports = __webpack_public_path__ + "files/123c427320aeab896c157a98232b8493.png";